import { render, staticRenderFns } from "./DraftsList.vue?vue&type=template&id=51301917&scoped=true&"
import script from "./DraftsList.vue?vue&type=script&lang=ts&"
export * from "./DraftsList.vue?vue&type=script&lang=ts&"
import style0 from "./DraftsList.vue?vue&type=style&index=0&id=51301917&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51301917",
  null
  
)

export default component.exports